export default __webpack_public_path__ + "static/map-d0d3c409080f8fe86e5c4270ccffe850.pdf";